{
  "loading": "로드 중…",
  "loadingMore": "추가 로드 중…"
}
